import {
    createVNode, render,
} from 'vue';

export const mountComponent = (component, { props, children, element } = {}) => {
    let el = element;

    let vNode = createVNode(component, props, children);
    if (el) render(vNode, el);
    else if (typeof document !== 'undefined') render(vNode, el = document.createElement('div'));

    const destroy = () => {
        if (el) render(null, el);
        el.remove();
        el = null;
        vNode = null;
    };

    return { vNode, destroy, el };
};
